module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "st-btn",
    class: {
      hidden: _vm.hidden
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.click($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46295f96","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/scrolltop/component.vue
// module id = 4aebc44dbedaf5605583
// module chunks = 0